export default {
    api_url: "https://lerncheck.studyhelp.de"
}



// WEBPACK FOOTER //
// ./src/config.js